<template>
  <template v-for="item in items" :key="item.id">
    <el-sub-menu v-if="item.type === 'directory'" :index="item.id">
      <template #title>
        <el-icon v-if="resolveAdminMenuIcon(item.icon)" class="menu-icon">
          <component :is="resolveAdminMenuIcon(item.icon)" />
        </el-icon>
        <span>{{ item.name }}</span>
      </template>
      <AdminMenuTree :items="item.children" />
    </el-sub-menu>
    <el-menu-item v-else :index="item.path">
      <el-icon v-if="resolveAdminMenuIcon(item.icon)" class="menu-icon">
        <component :is="resolveAdminMenuIcon(item.icon)" />
      </el-icon>
      <span>{{ item.name }}</span>
    </el-menu-item>
  </template>
</template>

<script setup lang="ts">
import type { AdminMenu } from '@/services/admin-api';
import { resolveAdminMenuIcon } from '@/components/admin-menu-icons';

export interface MenuNode extends AdminMenu { children: MenuNode[] }
defineProps<{ items: MenuNode[] }>();
</script>
